import React from 'react';
import AccountPage from '../components/AccountPage';
import ComingSoon from '../components/ComingSoon';

const ReviewsPage = () => {
  return (
    <AccountPage>
      <ComingSoon />
    </AccountPage>
  );
};

export default ReviewsPage;
